export default {
    pxToRem(px){
        return px / parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
    remToPx(rem){
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
}



//////////////////
// WEBPACK FOOTER
// ./public/js/services/cssUnitHelper.js
// module id = 64
// module chunks = 0